export default class ResumeNewsComponent{
    constructor(){
        let headerListSummary = document.querySelectorAll('.header-list-summary')
        let listSummary = document.querySelector('.list-summary')

        if(headerListSummary){
            headerListSummary.forEach(el => {
                el.addEventListener('click', function (event) {
                    listSummary.classList.toggle('active')                
                })
            })
        }
    }
}
new ResumeNewsComponent();